module.exports = __webpack_public_path__ + "img/pig.2edd5370.png";